import TagManager from "../tagManager/TagManager.vue";

export default {
  name: "TagManager",
  components: {
    "tag-manager": TagManager
  }
}